// eslint-disable-next-line
import * as tf from "@tensorflow/tfjs";
import * as blazeface from '@tensorflow-models/blazeface'
import { pTensorFlow, pGalibo, pStatus } from "../utils/parameters";

/* TIMER ID */
let interval;
let pCanvas;
let model;

/* Load model */
export async function loadBlazeFaceModel() {
    /* Load model */
    model = await blazeface.load({
        maxFaces: pTensorFlow.maxFaces,
        scoreThreshold: pTensorFlow.scoreThreshold
    });
}

/* Test model */
export async function testBlazeFaceModel(video) {
    console.log("s: " + video.readyState)
    if (video.readyState === 4) model.estimateFaces(video, false)
}

/* Run the engine */
export function runBlazeFace(video, canvas, setFaceStatus) {
    /* ID can be called to stop the interval */
    interval = setInterval(() => {
        detect(video, canvas, setFaceStatus)
    }, pTensorFlow.ts)
}

/* Stop interval, and therefore BlazeFace */
export function stopBlazeFace() {
    clearInterval(interval)
    interval = undefined;
}

/* True if BlazeFace is running */
export function checkBlazeFace() {
    if (interval !== undefined) return true;
    return false;
}

/* Called every 100 ms (recommended) */
async function detect(video, canvas, setFaceStatus) {
    /* Bounding boxes canvas */
    if (video !== undefined) {
        if (video.readyState === 4) {
            /* Pass in `true` to get tensors back, rather than values */
            const returnTensors = false;
            model.estimateFaces(video, returnTensors)
                .then(predictions => {
                    if (predictions.length > 0) {
                        const faceStart = predictions[0].topLeft;
                        const faceEnd = predictions[0].bottomRight;

                        /* Check if face is correctly positioned */
                        if (iouFace(pCanvas.start, pCanvas.end, faceStart, faceEnd)) {
                            setFaceStatus(pStatus.countdown);
                            stopBlazeFace();
                        }
                    }
                })
                .catch(e => console.error(e))
        }
    }
}

/* Check face */
/* Method 1: Check face position using easy maths */
// eslint-disable-next-line
function checkFacePosition(canvas, start, end) {
    var pX = canvas.width / 2 - pGalibo.width / 2;
    var pY = canvas.height / pGalibo.heightY - pGalibo.height / 2;

    /* If the face is correctly positioned then */
    if (start[0] > pX && start[1] > pY &&
        end[0] < (pX + pGalibo.width) && end[1] < (pY + pGalibo.height)) {
        return true
    }
    return false
}

/* Method 2: Check face position with  Intersection over unit */
/* iouFace(canvasStart, canvasEnd, faceStart, faceEnd) */
function iouFace(cS, cE, pS, pE) {
    /* Get intersection corners */
    const start = [Math.max(cS[0], pS[0]), Math.max(cS[1], pS[1])]
    const end = [Math.min(cE[0], pE[0]), Math.min(cE[1], pE[1])]

    /* Calculate intersection and boxes areas */
    const intersection = (end[0] - start[0]) * (end[1] - start[1])
    const galiboArea = Math.abs((cE[0] - cS[0]) * (cE[1] - cS[1]))
    const faceArea = Math.abs((pE[0] - pS[0]) * (pE[1] - pS[1]))

    /* IoU */
    const iou = intersection / (galiboArea + faceArea - intersection)
    console.log(iou)
    if (iou > 0 && iou > pGalibo.iouThreshold) return true
    return false
}

/* Draw the canvas face ref */
export function drawRef2(video, canvas) {
    const ctx = canvas.getContext('2d')
    pCanvas = getRefPoints(canvas, video)

    ctx.strokeStyle = pGalibo.color
    ctx.lineWidth = pGalibo.strokeWidth
    ctx.strokeRect(pCanvas.start[0], pCanvas.start[1], pGalibo.width, pGalibo.height)
}

export function drawRef(video, canvas) {
    const ctx = canvas.getContext('2d')
    pCanvas = getRefPoints(canvas, video)
    roundRect(ctx, pCanvas.start[0], pCanvas.start[1], pGalibo.width, pGalibo.height, 20)
}

/* Aux function to draw rects with round corners */
function roundRect(ctx, x, y, w, h, radius)
{
  var r = x + w;
  var b = y + h;

  ctx.beginPath();
  ctx.strokeStyle=pGalibo.color;
  ctx.lineWidth=pGalibo.strokeWidth;
  ctx.moveTo(x+radius, y);
  ctx.lineTo(r-radius, y);
  ctx.quadraticCurveTo(r, y, r, y+radius);
  ctx.lineTo(r, y+h-radius);
  ctx.quadraticCurveTo(r, b, r-radius, b);
  ctx.lineTo(x+radius, b);
  ctx.quadraticCurveTo(x, b, x, b-radius);
  ctx.lineTo(x, y+radius);
  ctx.quadraticCurveTo(x, y, x+radius, y);
  ctx.stroke();
}

export function clearRef(canvas) {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height)
}

function getRefPoints(canvas, video) {
    /* Galibo auxCanvas */
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    var pX = canvas.width / 2 - pGalibo.width / 2;
    var pY = canvas.height / pGalibo.heightY - pGalibo.height / 2;

    return {
        start: [pX, pY],
        end: [pX + pGalibo.width, pY + pGalibo.height]
    }
}

/* Render a rectangle over each detected face */
// eslint-disable-next-line
function drawFaceBoundingBox(canvas, video, start, end) {
    const ctx = canvas.getContext('2d');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const size = [end[0] - start[0], end[1] - start[1]];

    ctx.strokeStyle = "#ff0000";
    ctx.lineWidth = "2";

    ctx.strokeRect(start[0], start[1], size[0], size[1]);
}

